import OwAppointmentCalendar from './views/ow-appointment-calendar';
import OwAccCashTransactionsForm from './views/ow-acc-cash-transactions-form';
import OwViewRepDailySums from './views/ow-view-rep-daily-sums';
import OwAccCashtransactions from './views/ow-acc-cash-transactions';
import OwViewRepExpensesPeriodical from './views/ow-view-rep-expenses-periodical';
import OwExpensesForm from './views/ow-expenses-form';
import OwViewExpenses from './views/ow-view-expenses';
import OwViewRepClientAppointmentsWorkTypeAnalysis from './views/ow-view-rep-client-appointments-work-type-analysis';
import OwViewRepAppointmentsPerTechnician from './views/ow-view-rep-appointments-per-technician';
import OwUsergroups from './views/ow-usergroups';
import OwUsersForm from './views/ow-users-form';
import OwAppointmentCancellationTypes from './views/ow-appointment-cancellation-types';
import OwExpenses from './views/ow-expenses';
import OwExpenseTypes from './views/ow-expense-types';

import OwViewRepTotalappfrequencyyearturnover from './views/ow-view-rep-totalappfrequencyyearturnover';
import OwViewAppointmentsCheck from './views/ow-view-appointments-check';
import OwViewRepClientAppointmentsLate from './views/ow-view-rep-client-appointments-late';
import OwViewRepSalesPeridicalForecast from './views/ow-view-rep-sales-peridical-forecast';
import OwViewRepSalesMonthlyYearlySummary from './views/ow-view-rep-sales-monthly-yearly-summary';
import OwViewRepSalesYearlySummary from './views/ow-view-rep-sales-yearly-summary';
import OwViewRepClientAppointmentsAnalysis from './views/ow-view-rep-client-appointments-analysis';
import OwViewRepClientMonthlySummary from './views/ow-view-rep-client-monthly-summary';
import OwAppointmentsMessages from './views/ow-appointments-messages';
import OwViewRepCreditsInvoices from './views/ow-view-rep-credits-invoices';
import OwViewRepCredits from './views/ow-view-rep-credits';
import OwViewRepClientsAppointments from './views/ow-view-rep-clients-appointments';
import OwClientsForm from './views/ow-clients-form';
import OwAppointmentForm from './views/ow-appointments-form';
import OwViewRepDailyProgramme from './views/ow-view-rep-daily-programme';
import OwViewRepMonthlyProgramme from './views/ow-view-rep-monthly-programme';
import OwAppointments from './views/ow-appointments';
import OwUsers from './views/ow-users';
import OwAppointmentStatus from './views/ow-appointment-status';
import OwClientsSources from './views/ow-clients-sources';
import OwClients from './views/ow-clients';
import OwClientsCategories from './views/ow-clients-categories';
import OwClientTypes from './views/ow-client-types';
import OwWorkTypes from './views/ow-work-types';
import auth from "./auth";
import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";
//import defaultLayout from "./layouts/side-nav-inner-toolbar";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

import OParameters from './es-globals';
import navigation from './app-navigation';

function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Σύνδεση"
      },
      component: loadView("login-form")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },
    {
      path: "/",
      redirect: "/ow-view-rep-daily-programme"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }, 
    {
      path: "/ow-work-types",
      name: "ow-work-types",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwWorkTypes
    }, 
    {
      path: "/ow-client-types",
      name: "ow-client-types",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwClientTypes
    }, 
    {
      path: "/ow-clients-categories",
      name: "ow-clients-categories",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwClientsCategories
    }, 
    {
      path: "/ow-clients-sources",
      name: "ow-clients-sources",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwClientsSources
    }, 
    {
      path: "/ow-appointment-status",
      name: "ow-appointment-status",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointmentStatus
    }, 
    {
      path: "/ow-users",
      name: "ow-users",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwUsers
    }, 
    {
      path: "/ow-clients",
      name: "ow-clients",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwClients
    }, 
    {
      path: "/ow-appointments",
      name: "ow-appointments",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointments
    }, 
    {
      path: "/ow-view-rep-monthly-programme",
      name: "ow-view-rep-monthly-programme",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepMonthlyProgramme
    }, 
    {
      path: "/ow-view-rep-daily-programme",
      name: "ow-view-rep-daily-programme",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepDailyProgramme
    }, 
    {
      path: "/ow-appointments-form",
      name: "ow-appointments-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointmentForm
    }, 
    {
      path: "/ow-clients-form",
      name: "ow-clients-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwClientsForm
    }, 
    {
      path: "/ow-view-rep-clients-appointments",
      name: "ow-view-rep-clients-appointments",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientsAppointments
    }, 
    {
      path: "/ow-view-rep-credits",
      name: "ow-view-rep-credits",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepCredits
    }, 
    {
      path: "/ow-view-rep-credits-invoices",
      name: "ow-view-rep-credits-invoices",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepCreditsInvoices
    }, 
    {
      path: "/ow-appointments-messages",
      name: "ow-appointments-messages",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointmentsMessages
    }, 
    {
      path: "/ow-view-rep-client-monthly-summary",
      name: "ow-view-rep-client-monthly-summary",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientMonthlySummary
    }, 
    {
      path: "/ow-view-rep-client-appointments-analysis",
      name: "ow-view-rep-client-appointments-analysis",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientAppointmentsAnalysis
    }, 
    {
      path: "/ow-view-rep-sales-yearly-summary",
      name: "ow-view-rep-sales-yearly-summary",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepSalesYearlySummary
    }, 
    {
      path: "/ow-view-rep-sales-monthly-yearly-summary",
      name: "ow-view-rep-sales-monthly-yearly-summary",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepSalesMonthlyYearlySummary
    }, 
    {
      path: "/ow-view-rep-sales-peridical-forecast",
      name: "ow-view-rep-sales-peridical-forecast",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepSalesPeridicalForecast
    }, 
    {
      path: "/ow-view-rep-client-appointments-late",
      name: "ow-view-rep-client-appointments-late",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientAppointmentsLate
    }, 
    {
      path: "/ow-view-rep-clients-appointments",
      name: "ow-view-rep-clients-appointments",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientsAppointments
    }, 
    {
      path: "/ow-view-appointments-check",
      name: "ow-view-appointments-check",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewAppointmentsCheck
    }, 
    {
      path: "/ow-view-rep-totalappfrequencyyearturnover",
      name: "ow-view-rep-totalappfrequencyyearturnover",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepTotalappfrequencyyearturnover
    },
    {
      path: "/ow-expense-types",
      name: "ow-expense-types",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwExpenseTypes
    }, 
    {
      path: "/ow-expenses",
      name: "ow-expenses",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwExpenses
    }, 
    {
      path: "/ow-appointment-cancellation-types",
      name: "ow-appointment-cancellation-types",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointmentCancellationTypes
    },
    {
      path: "/ow-users-form",
      name: "ow-users-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwUsersForm
    }, 
    {
      path: "/ow-usergroups",
      name: "ow-usergroups",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwUsergroups
    }, 
    {
      path: "/ow-view-rep-appointments-per-technician",
      name: "ow-view-rep-appointments-per-technician",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepAppointmentsPerTechnician
    }, 
    {
      path: "/ow-view-rep-client-appointments-work-type-analysis",
      name: "ow-view-rep-client-appointments-work-type-analysis",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepClientAppointmentsWorkTypeAnalysis
    }, 
    {
      path: "/ow-view-expenses",
      name: "ow-view-expenses",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewExpenses
    }, 
    {
      path: "/ow-expenses-form",
      name: "ow-expenses-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwExpensesForm
    }, 
    {
      path: "/ow-view-rep-expenses-periodical",
      name: "ow-view-rep-expenses-periodical",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepExpensesPeriodical
    }, 
    {
      path: "/ow-acc-cash-transactions",
      name: "ow-acc-cash-transactions",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAccCashtransactions
    }, 
    {
      path: "/ow-view-rep-daily-sums",
      name: "ow-view-rep-daily-sums",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwViewRepDailySums
    }, 
    {
      path: "/ow-acc-cash-transactions-form",
      name: "ow-acc-cash-transactions-form",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAccCashTransactionsForm
    }, 
    {
      path: "/ow-appointment-calendar",
      name: "ow-appointment-calendar",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: OwAppointmentCalendar
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {

  if (to.name === "login-form" && auth.loggedIn()) {
    next({ name: "home" });
  }

  if (OParameters?.loggedUser?.user_group) {
    const userGroups = JSON.parse(OParameters.loggedUser.user_group).map(Number);
    /*  
      navigation.map((item) => {
        item.visible = item.level.some(level => userGroups.includes(level));
      })  
    */
  
    // NF 2025-05-25 - Recurse into nested menu items if they exist
    const applyMenuVisibility = (items) => {
      items.forEach(item => {
        // If level is defined, use it to determine visibility
        if (Array.isArray(item.level)) {
          item.visible = item.level.some(level => userGroups.includes(level));
        } else {
          // Default to non visible if no level is defined
          item.visible = false;
        }

        if (Array.isArray(item.items)) {
          applyMenuVisibility(item.items);
        }
      });
    };

    applyMenuVisibility(navigation);
  }


  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.loggedIn()) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
